import React from 'react';
import { Box, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import {
  Binoculars32,
  Activity32,
  ScalesTipped32,
  Earth32,
} from '@carbon/icons-react';
import Heading from '#coreComponents/Heading';

const info = [
  {
    title: 'Monitor reputation',
    description:
      "Discover what the world's academics and students think of your institution.",
    icon: Binoculars32,
  },
  {
    title: 'Demonstrate impact',
    description:
      'See how your strategy affects your performance on the world stage.',
    icon: Activity32,
  },
  {
    title: 'Support strategic decisions',
    description:
      'Understand your strengths and weaknesses to maximise your opportunities.',
    icon: ScalesTipped32,
  },
  {
    title: 'Spot new opportunities',
    description:
      'Find potential collaborators and competitors in a constantly changing landscape',
    icon: Earth32,
  },
];

const HomeInfo = () => (
  <Box>
    <Heading as="h2" textAlign="center" mb={6}>
      How can the rich data intelligence behind the world's most rigorous and
      trusted ranking of universities help your university improve?
    </Heading>
    <SimpleGrid columns={[1, 2]} spacing={4}>
      {info.map(({ title, description, icon }) => (
        <VStack key={title} alignItems="center" spacing={2}>
          <Text fontWeight="bold" fontSize="xl">
            {title}
          </Text>
          <Box as={icon} color="blue.700" />
          <Text textAlign="center">{description}</Text>
          <Box>
            <Box
              my={2}
              as="hr"
              borderWidth={1}
              borderColor="gray.600"
              borderTopStyle="solid"
              width={100}
              height={0}
            />
          </Box>
        </VStack>
      ))}
    </SimpleGrid>
  </Box>
);

export default HomeInfo;
